import { ApiUrl2,UserToken } from '../../../helper/HelperAuth'
import { GlobalLoading } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'
import {fromJS} from "immutable";

export default (param) => async (dispatch) => {
    let formdata = new FormData();
    
    param.map((k,v) => {
        formdata.append(v,k);    
    });
    
    const url = ApiUrl2+'helpdesk-closeticket';
    const argument = {
        method: 'POST',
        headers : {
            'Authorization': 'Bearer ' + UserToken,
        },
        body: formdata
    };
    const response = await doFetch(url,argument);

    // dispatch({ type: GlobalLoading, showLoading: false, latestProcessStatus : response.ok });
    // return response;
    try{
        if(response.ok){
            var res = fromJS(await response.json());
            // res = res.get('data');
            // res = res.get(0)
            return fromJS({
                'success': true,
                "message": res.get('message'),
                "closed-date": res.get('closed-date')
            });
        }
    }catch(ex){

    }

    return fromJS({
        'success': false
    })
};